import { render, staticRenderFns } from "./LawTrendNews.vue?vue&type=template&id=28ce4708"
import script from "./LawTrendNews.vue?vue&type=script&lang=js"
export * from "./LawTrendNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports